module.exports = __webpack_public_path__ + "img/checked-favor_s.c845e340.svg";